export default "__VITE_ASSET__Dap1nTbh__"